let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("gwV0J"), load("3t6fF"), load("bKvoJ")]).then(() => parcelRequire('aFK6m'));